import { useMutation, useQueryClient } from 'react-query'

import { permissionRepository } from '@webapp/platform/iam/data-access/repositories/PermissionRepository'
import { reportAccessGrantQueryConfig } from '@webapp/platform/iam/query-configs/reportAccessGrant'
import { reportAccessSecondaryCategoryQueryConfig } from '@webapp/platform/iam/query-configs/reportAccessSecondaryCategory'

export const useMutateGrantReportAccessToAllSecondaryCategories = () => {
  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: ({
      primaryCategoryId,
      userId,
    }: {
      primaryCategoryId: number
      userId: number
    }) =>
      permissionRepository.grantReportAccessToAllSecondaryCategories({
        primaryCategoryId,
        userId,
      }),
    onSuccess: (_, { primaryCategoryId }) => {
      // Every SecondaryCategory in the PrimaryCategory changed — invalidate
      // all grants lists and that PrimaryCategory's lists (partial keys, ADR-5)
      queryClient.invalidateQueries(
        reportAccessGrantQueryConfig.list().queryKey
      )
      queryClient.invalidateQueries(
        reportAccessSecondaryCategoryQueryConfig.list(primaryCategoryId)
          .queryKey
      )
    },
  })

  return {
    grantReportAccessToAllSecondaryCategories: mutateAsync,
    isGranting: isLoading,
  }
}
